import {
  VALID_DATE_FORMATS,
  displayDate,
  displayTime,
} from '@adsk/alloy-react-datetime';

const formatCreatedOn = (createdOn: Date | string, locale?: string) => {
  return [
    displayDate(new Date(createdOn), {
      format: VALID_DATE_FORMATS.NUMERIC,
      locale,
    }),
    displayTime(new Date(createdOn), { locale }),
  ].join(' ');
};

export default formatCreatedOn;
